import {useState,useEffect, useContext} from 'react'
import Container from '../../Components/Auth/Logout'
import {Helmet} from "react-helmet";
import { GeneralFunctionsContext } from '../../Components/Contexts/GeneralFunctionsContext';

export default function Logout () {
     const {innerWidth, offset} = useContext(GeneralFunctionsContext);
    
    return (
        <>
        
        <Helmet>
            <title>Logout</title>
            <meta property="og:title" content="Logout"/>
            <meta name="title" content="Logout"/>
            <meta name="description" content="Logout of geniux music"/>
            <meta property="og:image" content="/assets/images/geniux_music_logo.png"/>
        </Helmet>
         <Container innerWidth={innerWidth} /> 
            
        </>
    )
}


